import { render, staticRenderFns } from "./couponsView.vue?vue&type=template&id=941b31b0&scoped=true&"
import script from "./couponsView.vue?vue&type=script&lang=js&"
export * from "./couponsView.vue?vue&type=script&lang=js&"
import style0 from "./couponsView.vue?vue&type=style&index=0&id=941b31b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941b31b0",
  null
  
)

export default component.exports